import styled from 'styled-components';
import {colors, devices, sizes} from "../../utils/styled/_variables.styled";

export const InfiosSearchResults = styled.section`
    display: flex;
    flex-direction: column;
    max-width: ${props => props.fullWidth === 'fullwidth' ? '1512px' : '870px'}!important;

    .content__list__itens{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .heading-4 {
        margin-bottom: 32px;
        max-width: 870px;

        @media ${devices.mobile} {
            margin-bottom: 12px;
        }
    }
`;

export const InfiosSearchNotFound = styled.section`
    display: flex;
    flex-direction: column;
    justify-self: flex-start;

    .search-suggestions {
        display: flex;
        flex-direction: row;
        align-items: center;

        @media ${devices.mobile} {
            align-items: flex-start;
            flex-direction: column;
        }

        &__link {
            display: flex;
            flex-direction: row;
            gap: 18px;

            @media ${devices.mobile} {
                max-width: 100%;
                flex-wrap: wrap;
            }
        }

        p {
            @media ${devices.mobile} {
                margin-bottom: 16px;
            }
        }

        a {
            display: flex;
            justify-content: flex-start;
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            margin-left: 16px;

            @media ${devices.mobile} {
                max-width: 100%;
                margin-left: 0;
            }
        }


    }
`;

export const InfiosPaginationWrapper = styled.div`
    ${props => props.isHidden ? 'display:none;' : ''}
    ${props => props.isLoading ? 'pointer-events: none; opacity: 0.2;' : ''}
    ul{
        height: 50px;
        display: flex;
        padding-left: 0;
        list-style: none;
        gap: 10px;
        justify-content: flex-end;
        align-items: center;
        li{
            a{
                cursor: pointer;
                color: ${colors.infiosGray};
                &:hover {
                    color: ${colors.infiosGray};
										text-decoration: underline;
                }
            }
            &.active{
                a{
                    color: ${colors.infiosGray};
                    text-decoration: underline;
                    text-underline-offset: 4px;
                    text-decoration-thickness: 3px;
                }
            }
            &.disabled{
                display:none;
            }
        }
        li:first-of-type {
            margin-right: 10px;
        }
        li:last-of-type {
            margin-left: 10px;
        }

        @media (max-width: ${sizes.tabletSmall}px) {
            justify-content: flex-end;
        }
    }

    &.top-pagination{
        margin-bottom: 50px;
    }

    &.bottom-pagination{
        margin-top: 50px;
    }

`
